import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {plainToClass} from "class-transformer";

import {Format} from "../enums/format.enum";
import {ApprovalRequest, ApprovalStatus} from "./approval-status";
import {ApprovalStatusDataService} from "./approval-status-data.service";
import {CommonDataService} from "../services/common-data.service";
import {PrimeNgConfig} from "@app/shared/classes/prime-ng-config";
import {TableColumn} from "@app/shared/classes/table-column";

@Component({
  selector: "app-approval-status",
  templateUrl: "./approval-status.component.html",
  styleUrls: ["./approval-status.component.css"],
  providers: [ApprovalStatusDataService]
})
export class ApprovalStatusComponent implements OnInit {

  // standard format and validation
  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;

  approvalStatus: ApprovalStatus[];
  showApprovalStatusDialog: boolean;
  approvalStatusColumns: TableColumn[];

  @Input()
  managingOrgId: number;

  private _request: ApprovalRequest;
  @Input()
  set request(value: ApprovalRequest) {
    if (value) {
      this._request = value;
      this.getApprovalStatus(value);
    } else {
      console.debug("approval-status:set request = undefined value");
    }
  }

  get request(): ApprovalRequest {
    return this._request;
  }

  @Output() handler: EventEmitter<ApprovalStatus[]> = new EventEmitter();

  constructor(private commonDataService: CommonDataService, private dataService: ApprovalStatusDataService) {
  }

  ngOnInit() {
    this.approvalStatusColumns = [
      {field: 'index', header: '#', columnStyle: "text-align:center;width:70px;"},
      {field: 'actionTaken', header: 'Action', columnStyle: "text-align:center;width:90px;"},
      {field: 'actionOn', header: 'Action On', columnStyle: "text-align:center;width:150px;"},
      {field: 'actionBy', header: 'By'},
      {field: 'responseMessage', header: 'Comments'}
    ];
  }

  getApprovalStatus(request: ApprovalRequest): void {
    if (request && request.transaction) {
      this.dataService.getApprovalStatusByTxnType(request.refId, request.transaction, this.managingOrgId).subscribe(res => {
        this.approvalStatus = plainToClass(ApprovalStatus, res.approvals);
        this.processApprovalStatus(request, this.approvalStatus);
      });
    } else {
      console.error("approval-status: txnTypeId or txnTypeName is required");
    }
  }

  processApprovalStatus(request: ApprovalRequest, approvalStatus: ApprovalStatus[]): void {
    this.showApprovalStatusDialog = request.showStatusInDialog;
    if (request.emitStatus) {
      this.handler.emit(approvalStatus);
    }
  }

  close(): void {
    this.showApprovalStatusDialog = false;
  }
}
